import { Link } from "gatsby"
import React from "react"
import { Header, Footer, SignupForm } from "../components"

export const LayoutFull = ({ children }) => {
  return (
    <>
      <Header /> 
      {children}

      <Footer />
    </>
  )
}
